export const MAX_API_RESPONSE_WAIT_TIME = 1000 * 60 * 15 * 2; // 30 minutes
